import { render, staticRenderFns } from "./ContractCustomerSection.vue?vue&type=template&id=596db531&scoped=true&"
import script from "./ContractCustomerSection.vue?vue&type=script&lang=js&"
export * from "./ContractCustomerSection.vue?vue&type=script&lang=js&"
import style0 from "./ContractCustomerSection.vue?vue&type=style&index=0&id=596db531&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596db531",
  null
  
)

export default component.exports